<template>
  <div
    class="plant-row"
    :class="{ 'plant-row--selected': isSelected }"
    :data-testid="`plant-row-${plant.id}`"
    @click="$emit('select', plant.id)"
  >
    <div class="plant-row__content">
      <span class="plant-row__name">{{ plant.name }}</span>
      <div class="plant-row__meta">
        <span v-if="!plant.last_update" class="plant-row__status plant-row__status--none">
          {{ $t('component_no_data') }}
        </span>
        <template v-else>
          <span
            class="plant-row__dot"
            :class="isStale ? 'plant-row__dot--stale' : 'plant-row__dot--fresh'"
          ></span>
          <span class="plant-row__time">{{ formattedLastUpdate }}</span>
        </template>
        <svg
          class="plant-row__chevron"
          :class="{ 'plant-row__chevron--open': isSelected }"
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
        >
          <path
            d="M1 1l6 5.5L1 12"
            stroke="#c7c7cc"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlantListItem',
  emits: ['select'],
  props: {
    plant: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
    staleThresholdMs: { type: Number, default: 7200000 },
  },
  computed: {
    isStale() {
      if (!this.plant.last_update) return false;
      return Date.now() - new Date(this.plant.last_update).getTime() > this.staleThresholdMs;
    },
    formattedLastUpdate() {
      if (!this.plant.last_update) return '';
      return new Date(this.plant.last_update).toLocaleString('de-DE', {
        day: 'numeric',
        month: '2-digit',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
      });
    },
  },
};
</script>

<style scoped>
.plant-row {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.12s ease;
  -webkit-tap-highlight-color: transparent;
}

.plant-row:active {
  background: #f2f2f7;
}

.plant-row--selected {
  background: #f2f2f7;
}

.plant-row__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 28px;
}

.plant-row__name {
  font-size: 15px;
  font-weight: 500;
  color: #1d1d1f;
  flex: 1;
  margin-right: 12px;
}

.plant-row__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.plant-row__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.plant-row__dot--fresh {
  background: #34c759;
}

.plant-row__dot--stale {
  background: #ff9500;
}

.plant-row__time {
  font-size: 13px;
  color: #6e6e73;
}

.plant-row__status {
  font-size: 13px;
}

.plant-row__status--none {
  color: #aeaeb2;
}

.plant-row__chevron {
  margin-left: 4px;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.plant-row__chevron--open {
  transform: rotate(90deg);
}
</style>
